module.exports = __webpack_public_path__ + "Flag-10.2556645d804bf732bed2bc336a56a9b3.svg";